export const BANNER_CURRENT_INDEX = "BANNER_CURRENT_INDEX";
export const GETALLSTORES = "GETALLSTORES";
export const UPDATESITEMAP = "UPDATESITEMAP";
export const CFW_IS_MOBILE = "IS_MOBILE";
export const CFW_SCROLL_COUNTER = "SCROLL_COUNTER";
export const CFW_LOAD_ON_SCROLL = "LOAD_ON_SCROLL";
export const CFW_SCROLL_COUNTER_PROCESSED = "SCROLL_COUNTER_PROCESSED";
export const CFW_CLIENT_COUNTRY = "CLIENT_COUNTRY";
export const CFW_DROPDOWN_COUNTRY = "DROPDOWN_COUNTRY";
export const CFW_CURRENT_TRANSLATION = "CURRENT_TRANSLATION";
export const CFW_LOAD_MENU = "LOAD_MENU";
export const CFW_HYDRATION_COMPLETE = "HYDRATION_COMPLETE";
export const CFW_SEARCH = "SEARCH";
export const CFW_GLOBAL = "GLOBAL";
export const CFW_NON_PERSISTENT_STATE = "NON_PERSISTENT_STATE";
export const CFW_PROMISE_FETCHER_STATE = "PROMISE_FETCHER_STATE";
export const CFW_UPDATE_DEFAULT_DATA = "UPDATE_DEFAULT_DATA";
export const GOOGLE_MAP_SET_CENTER = "GOOGLE_MAP_SET_CENTER";
export const CFW_PRODUCTCODE = "PRODUCTCODE";
export const CFW_FACEBOOKID = "FacebookId";
export const CFW_LINKEDINID = "LinkedInId";
export const CFW_GOOGLEID = "GoogleId";
export const CFW_POINTS = "Points";
export const CFW_LOGINFO = "urtechcity_user";
export const CFW_PAGE_INFO = "PAGE_INFO";
export const CFW_SOCIALLINKING = "SOCIALLINKING";
export const CFW_SOCIAL_INTEGRATION = "SOCIAL_INTEGRATION";
export const CFW_TEMPORARYUSERNAME = "TEMPORARYUSERNAME";
export const CFW_TEMPORARYPICTURE = "TEMPORARYPICTURE";
export const CFW_TWITTERID = "TwitterId";
export const CFW_ERROR = "ERROR";
export const CFW_CURRENT_URL = "CURRENT_URL";
export const CFW_CURRENT_LANGUAGE = "CURRENT_LANGUAGE";
export const PROCESS_ADD = "ADD";
export const PROCESS_ACCEPT = "ACCEPT";
export const PROCESS_UPDATE = "UPDATE";
export const PROCESS_INQUIREPROPOSAL = "INQUIREPROPOSAL";
export const PROCESS_SELECTMESSAGECOUNT = "SELECTMESSAGECOUNT";
export const PROCESS_ADDDETAILS = "ADDDETAILS";
export const PROCESS_EDITDETAILS = "EDITDETAILS";
export const PROCESS_DELETEDETAILS = "DELETEDETAILS";
export const PROCESS_RETRIEVEEMAILS = "RETRIEVEEMAILS";
export const PROCESS_ADDMESSAGE = "ADDMESSAGE";
export const PROCESS_EDITALL = "EDITALL";
export const PROCESS_TASKS = "TASKS";
export const PROCESS_VIEWJOBPOST = "VIEWJOBPOST";
export const PROCESS_UPDATESTATUS = "UPDATESTATUS";
export const PROCESS_CHANGESTATUS = "CHANGESTATUS";
export const PROCESS_EMPLOYERMONTHLYTASKS = "EMPLOYERMONTHLYTASKS";
export const PROCESS_ADDTOQUEUE = "ADDTOQUEUE";
export const PROCESS_DELETEAPPLICATION = "DELETEAPPLICATION";
export const PROCESS_DELETE = "DELETE";
export const PROCESS_UPDATEPOINTS = "UPDATEPOINTS";
export const PROCESS_EDIT = "EDIT";
export const PROCESS_GETTOTALS = "GETTOTALS";
export const PROCESS_ISEXISTS = "ISEXISTS";
export const PROCESS_SELECT = "SELECT";
export const CFW_LOGOUT = "LOGOUT";
export const PROCESS_SELECT_SITEMAP = "SELECT_SITEMAP";
export const PROCESS_SELECT_DROPDOWN = "SELECT_DROPDOWN";
export const PROCESS_UPDATECATEGORY = "UPDATECATEGORY";
export const CFW_ACTIVATE_SOCIAL_BUTTONS = "ACTIVATE_SOCIAL_BUTTONS";
export const CFW_REFRESHER = "CFW_REFRESHER";
export const CFW_BANNER_REFRESHER = "CFW_BANNER_REFRESHER";
export const REGEXP_EMAIL =
  "([A-Za-z0-9][._]?)+[A-Za-z0-9]@[A-Za-z0-9]+(.?[A-Za-z0-9]){2}.([A-Za-z0-9]{3,4})+(.[A-Za-z0-9]{2,4})?";
export const REGEXP_PASSWORD =
  "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$";
export const REGEXP_NUMBER = "^[0-9]*$";
export const REGEXP_DECIMAL = "([0-9]+.)?[0-9]+";
export const REGEXP_URL =
  "(\b(https?|ftp|file)://)?[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]";
export const REGEXP_IMAGEURL = "https?:[^)'\"]+.(?:jpg|jpeg|gif|png)";
export const REGEXP_REMOVETAGS = /(<([^>]+)>)/gi;
export const Response_BannerData = "BannerData";
export const Response_ProductData = "ProductData";
export const Response_SiteMapUrlData = "SiteMapUrlData";
export const Response_DynamicOptionsData = "DynamicOptionsData";
export const Response_LoginData = "LoginData";
export const Response_UsersData = "UsersData";
export const Response_TranslationData = "TranslationData";
export const Response_SelectedTranslation = "SelectedLanguage";
export const Response_TranslationItem = "TranslationItem";
export const Response_SiteMapData = "SiteMapData";
export const Response_ClientProfileData = "ClientProfileData";
export const Response_FileDowloadData = "FileDowloadData";

export const PRODUCTCODES_URTECHCITY = "URTECHCITY";
export const PRODUCTCODES_JOBPORTAL = "JOBPORTAL";
export const PRODUCTCODES_UPUBLISHME = "UPUBLISHME";
export const PRODUCTCODES_URTECHPOS = "URTECHPOS";
export const PRODUCTCODES_URTECHSHOP = "URTECHSHOP";
export const PRODUCTCODES_URTECHPOGO = "URTECHPOGO";

export const DIALOGHOLDER = "DIALOGHOLDER";
export const FILTERHOLDER = "FILTERHOLDER";
export const FileType_Image = 4;
export const FileType_ProfliePicture = 8;
export const CONTACT_DETAILS =
  "4209 Rockside Hills Drive, Raleigh, North Carolina, USA<br /><br /><b>{0} #:</b><br />+1(919)-400-9111<br /><b>{1} #:</b><br />+1(919)-675-5887<br /><b>{2}:</b><br />contactus@urtechcity.com";
export const PAY_RATES = [
  {
    RateType: "HourlyRate",
    OfferRateType: "OfferHourlyRate",
    Tran: 202,
    OfferTran: 215,
  },
  {
    RateType: "DailyRate",
    OfferRateType: "OfferDailyRate",
    Tran: 201,
    OfferTran: 214,
  },
  {
    RateType: "WeeklyRate",
    OfferRateType: "OfferWeeklyRate",
    Tran: 161,
    OfferTran: 216,
  },
  {
    RateType: "MonthlyRate",
    OfferRateType: "OfferMonthlyRate",
    Tran: 160,
    OfferTran: 217,
  },
];
